var windowRef = null
var windowTimer = null
var callback = null

function release() {
    windowRef = null

    if (windowTimer) {
        clearInterval(windowTimer)
        windowTimer = null
    }

    if (callback) {
        window.removeEventListener('message', onMessage, false)
    }
}

function onMessage(e) {
    if (e.origin.startsWith(process.env.VUE_APP_SERVER_DOMAIN)) {
        callback(e.data)
    }
}

export default {
    open(url) {
        windowRef = window.open(url, "AuthWindow", "width=500,height=500")
        windowRef.focus()
    },
    close() {
        if (windowRef) {
            windowRef.close()
            release()
            return true
        }

        return false
    },
    onMessage(func) {
        if (windowRef) {
            callback = func;
            window.addEventListener('message', onMessage, false)
            return true
        }

        return false;
    },
    onClose(func) {
        if (windowRef) {
            windowTimer = setInterval(function() {
                if (windowRef.closed) {
                    release()
                    func()
                }
            }, 1000)

            return true
        }

        return false
    }
}